import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/whatsapp-special-broadcasts';

class SpecialWhatsAppBroadcastService {
  async list({ page = 1, limit = 20 } = {}) {
    const response = await apiClient.get(BASE, { params: { page, limit } });
    return response.data;
  }

  async getActive() {
    const response = await apiClient.get(`${BASE}/active`);
    return response.data;
  }

  async create(payload) {
    const response = await apiClient.post(BASE, payload);
    return response.data;
  }

  async update(uuid, payload) {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response.data;
  }

  async preview(uuid) {
    const response = await apiClient.get(`${BASE}/${uuid}/preview`);
    return response.data;
  }

  async sendOne(uuid, groupUuid) {
    const response = await apiClient.post(`${BASE}/${uuid}/send`, {
      group_uuid: groupUuid,
    });
    return response.data;
  }

  async sendAll(uuid) {
    const response = await apiClient.post(`${BASE}/${uuid}/send-all`);
    return response.data;
  }

  async cancel(uuid) {
    const response = await apiClient.post(`${BASE}/${uuid}/cancel`);
    return response.data;
  }
}

const specialWhatsAppBroadcastService = new SpecialWhatsAppBroadcastService();
export default specialWhatsAppBroadcastService;
